<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      太子湾站<br>
站点介绍<br>
太子湾站车站主体位于汇海路上，位于汇海路和邮轮大道路叉口东侧，沿汇海路呈东西向布置，现状车站站点周边规划主要为商业、办公用地。近招商蛇口邮轮母港，利于市民绿色出行。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:22	23:02	12号线	4分钟	8分钟<br>
海上田园东	06:46	00:10	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:18	23:02	12号线	8分钟	8分钟<br>
海上田园东	06:47	00:10	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
港湾大道南侧、艺城湾樽、蛇口邮轮母港<br><br>
B出入口:<br>
商海路东侧（近期开通）<br><br>
C出入口:<br>
商海路东侧<br><br>
D出入口:<br>
汇海路北侧、太子湾壹栈人才公寓、太子湾湾玺N1栋（近期开通）<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 邮轮中心总站<br>
M105、M157<br><br>
C出入口:<br>
公交站名： 蛇口港地铁站<br>
22、70、80、113、122、226、331、332、M105、M106、M400、M409、M430、M448、B601<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>